import React from "react";
import './secondarymessage.css'
import {
    Row,
    Col,
    // Button,
    // Image, 
    Container,
} from "react-bootstrap";
// import bookIcon from '../../icons/book-icon.png'
// import findIcon from '../../icons/find-icon.png'
// import visitIcon from '../../icons/visit-icon.png'



export default function SecondaryMessage() {
    return (
        <div>
            <Container fluid="lg">
                <Row xs={1} md={2} lg={2} className="mt-5" >
                    <Col >
                        <h1>Curated options, better choices.</h1>
                        <h5>We spent thousands of hours vetting dentists all over UAE so you can easily find and book a nearby dentist that’s perfect for you.</h5>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}